import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = ({
  isValid, redirectTo = '/', ...rest
}) => (isValid ? <Outlet {...rest} /> : <Navigate to={redirectTo} replace />);


export default ProtectedRoute;
